export default __webpack_public_path__ + "static/media/clock-game.5459db04.jpg";